<template>
  <div>
    <el-form :inline="true" class="selectForm">
      <el-select
        v-model="searchForm.schoolName"
        placeholder="筛选学校信息"
        @change="selectSchool"
        clearable>
        <el-option
          v-for="item in searchForm.schoolOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.building"
        placeholder="筛选寝室楼信息"
        @change="selectBuilding"
        clearable>
        <el-option
          v-for="item in searchForm.buildingOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.room"
        placeholder="筛选寝室信息"
        @change="reloadTableData"
        clearable>
        <el-option
          v-for="item in searchForm.roomOption"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        @click="downloadTable"
        icon="el-icon-document"
        :loading="downloadLoading">
        下载
      </el-button>
      <!--<el-select-->
        <!--v-model="searchForm.roomStatus"-->
        <!--placeholder="筛选寝室状态"-->
        <!--@change="reloadTableData"-->
        <!--clearable>-->
        <!--<el-option-->
          <!--v-for="item in searchForm.roomStatusOption"-->
          <!--:key="item"-->
          <!--:value="item">-->
        <!--</el-option>-->
      <!--</el-select>-->
    </el-form>
    <el-table
      :data="tableData"
      border
      stripe
      v-loading="tableLoading"
      height="300px"
      element-loading-text="拼命加载中">
      <el-table-column prop="schoolName" label="学校"></el-table-column>
      <el-table-column prop="building" label="寝室楼"></el-table-column>
      <el-table-column prop="room" label="寝室号"></el-table-column>
      <el-table-column prop="stuNameDesen" label="付款者"></el-table-column>
      <!--<el-table-column prop="number" label="人数"></el-table-column>-->
      <el-table-column prop="payTime" label="付款时间"></el-table-column>
      <el-table-column prop="name" label="资费类型"></el-table-column>
      <el-table-column prop="rent" label="租金（元）"></el-table-column>
      <el-table-column prop="deposit" label="押金（元）"></el-table-column>
      <el-table-column prop="total" label="合计（元）"></el-table-column>
      <el-table-column prop="transactionId" label="微信订单号"></el-table-column>
      <el-table-column prop="statusDesc" label="订单状态"></el-table-column>

      <!--<el-table-column label="操作">-->
        <!--<template slot-scope="scope">-->
          <!--<el-button-->
            <!--type="primary"-->
            <!--@click="editDormitory(scope.row)"-->
            <!--size="small"-->
            <!--icon="el-icon-edit">-->
            <!--查看寝室-->
          <!--</el-button>-->
        <!--</template>-->
      <!--</el-table-column>-->
    </el-table>
    <el-pagination
      @current-change="currentChange"
      @size-change="sizeChange"
      :page-sizes="[5, 10,15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      :total=pagination.total>
    </el-pagination>

    <el-dialog
      title="编辑寝室信息"
      :visible.sync="dialogVisible"
      width="400px">
      <el-form
        :model="dialogForm"
        label-width="120px"
      >
        <el-form-item label="学校">
          <label>{{dialogForm.schoolName}}</label>
        </el-form-item>
        <el-form-item label="寝室楼">
          <label>{{dialogForm.building}}</label>
        </el-form-item>
        <el-form-item label="寝室号">
          <label>{{dialogForm.room}}</label>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="dialogForm.gender">
            <el-radio label=0>男</el-radio>
            <el-radio label=1>女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="人数" class="input-item">
          <el-input-number v-model="dialogForm.number"
                           :min="1"
                           :max="8"
                           size="mini">
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateRoom">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosByJson, axiosByKeyValue } from '../axios/index';

export default {
  name: 'Room',
  data() {
    return {
      searchForm: {
        schoolName: '',
        building: '',
        room: '',
        roomStatus: '',
        schoolOptions: [],
        buildingOptions: [],
        roomOption: [],
        roomStatusOption: ['租赁中', '空置中'],
      },
      tableData: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      tableLoading: false,
      downloadLoading: false,
      dialogVisible: false,
      dialogForm: {
        gender: '0',
        number: 1,
      },
    };
  },
  methods: {
    initSchoolOption() {
      axiosByJson.post('listSchool').then(({ data: { data } }) => {
        this.searchForm.schoolOptions = data;
      });
    },
    initBuildingOption() {
      axiosByKeyValue.post('listBuilding', {
        schoolName: this.searchForm.schoolName,
      }).then(({ data: { data } }) => {
        this.searchForm.buildingOptions = data;
      });
    },
    initRoomOption() {
      axiosByKeyValue.post('listRoom', {
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
      }).then(({ data: { data } }) => {
        this.searchForm.roomOption = data;
      });
    },
    sizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.reloadTableData();
    },
    currentChange(currentPage) {
      this.pagination.pageNo = currentPage;
      this.reloadTableData();
    },
    selectSchool(value) {
      this.searchForm.building = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.buildingOptions = [];
      } else {
        this.initBuildingOption();
      }
    },
    selectBuilding(value) {
      this.searchForm.room = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    selectBuildingStatus(value) {
      this.searchForm.roomStatus = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    updateRoom() {
      axiosByJson.post('updateRoom', {
        schoolName: this.dialogForm.schoolName,
        building: this.dialogForm.building,
        room: this.dialogForm.room,
        gender: parseInt(this.dialogForm.gender, 10),
        number: this.dialogForm.number,
      }).then(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.reloadTableData();
      }).catch(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'error',
          message: '系统异常',
        });
      });
    },
    unRent(row) {
      if (row.statusDesc === '空置中') {
        this.$message({
          type: 'error',
          message: '空置寝室不允许退租2',
        });
        return;
      }
      this.tableLoading = true;
      axiosByJson.post('unRent', {
        schoolName: row.schoolName,
        building: row.building,
        room: row.room,
      }).then(() => {
        this.tableLoading = false;
        this.$message({
          type: 'success',
          message: '操作成功',
        });
        this.reloadTableData();
      }).catch(() => {
        this.dialogVisible = false;
        this.$message({
          type: 'error',
          message: '系统异常',
        });
      });
    },
    reloadTableData() {
      this.tableLoading = true;
      axiosByJson.post('listAllOrderInfo', {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
        room: this.searchForm.room,
      }).then(({ data: { data: { count, list } } }) => {
        list.forEach((val) => {
          Object.assign(val, {
            statusDesc: val.status === 'RENTING' ? '进行中' : '已退租',
            stuNameDesen: val.stuName == null ? null : val.stuName.substring(0, 1) + '**',
          });
        });
        this.tableData = list;
        this.pagination.total = count;
        this.tableLoading = false;
      });
    },
    downloadTable() {
      this.downloadLoading = true;
      axiosByJson.post('listAllOrderInfo', {
        pageNo: 0,
        pageSize: this.pagination.pageSize,
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
        room: this.searchForm.room,
      }).then(({ data: { data: { list } } }) => list).then((data) => {
        const csvContentHeader = 'data:text/csv;charset=utf-8,\uFEFF';
        let csvContent = '';
        const header = '学校,寝室楼,寝室号,付款者,付款时间,资费类型,租金（元）,押金（元）,合计（元）,微信订单号,订单状态';
        csvContent += `${header}\r\n`;
        data.forEach((rowObj) => {
          const row = `${rowObj.schoolName},${rowObj.building},${rowObj.room},${rowObj.stuName},${rowObj.payTime},${rowObj.name},${rowObj.rent},${rowObj.deposit},${rowObj.total},${rowObj.transactionId == null ? '' : '`' + rowObj.transactionId},${rowObj.status === 'RENTING' ? '进行中' : '已退租'},`;
          csvContent += `${row}\r\n`;
        });
        csvContent = encodeURIComponent(csvContent);
        const encodedUri = csvContentHeader + csvContent;
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', '订单导出.csv');
        document.body.appendChild(link);
        link.click();
        this.downloadLoading = false;
      });
    },
    editDormitory(row) {
      Object.assign(this.dialogForm, row, { gender: row.gender.toString() });
      this.dialogVisible = true;
    },
  },
  created() {
    this.reloadTableData();
    this.initSchoolOption();
  },
};
</script>

<style scoped>
  .selectForm {
    text-align: center;
    margin-bottom: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Order.vue